import MUITableHead, { TableHeadProps } from "@material-ui/core/TableHead";

const TableHead = (props: TableHeadProps) => <MUITableHead {...props} />;

export default TableHead;
